// railfix v33 2026-06-09T23 force shard refresh
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from "./App.js?v=v37-hottub-1753574400000";
const rootElement = document.getElementById('root');
if (!rootElement) {
    throw new Error("Could not find root element to mount to");
}
const root = ReactDOM.createRoot(rootElement);
root.render(React.createElement(React.StrictMode, null,
    React.createElement(App, null)));
